import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

import { uniqueKey } from "@utils/react";

const useStyles = makeStyles(() => ({
  breadcrumbs: {
    marginBottom: "16px",
    "@media all and (min-width: 1024px)": {
      fontSize: "1.25rem !important",
      marginBottom: "30px",
    },
  },
  breadcrumbsItem: {
    fontSize: "inherit",
  },
  breadcrumbsItemLink: {
    fontSize: "inherit",
    textDecoration: "none",
    color: "rgba(0, 0, 0, 0.54)",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  breadcrumbsItemNoLink: {
    fontSize: "inherit",
    color: "rgba(0, 0, 0, 0.54)",
  },
}));

function AdminPage(props) {
  const classes = useStyles();
  const lastBreadIndex = props.breadcrumbs.length - 1;
  return (
    <React.Fragment>
      <Breadcrumbs className={classes.breadcrumbs} aria-label="breadcrumbs">
        {props.breadcrumbs.map((route, i) => {
          if (lastBreadIndex === i) {
            return (
              <Typography
                className={classes.breadcrumbsItem}
                key={uniqueKey("breadcrumbs")}
                color="textPrimary"
              >
                {route.label}
              </Typography>
            );
          }
          if (!route.path) {
            return (
              <Typography
                className={classes.breadcrumbsItemNoLink}
                key={uniqueKey("breadcrumbs")}
                color="textPrimary"
              >
                {route.label}
              </Typography>
            );
          }
          return (
            <Link
              className={classes.breadcrumbsItemLink}
              key={uniqueKey("breadcrumbs")}
              color="inherit"
              to={route.path}
            >
              {route.label}
            </Link>
          );
        })}
      </Breadcrumbs>
      {props.children}
    </React.Fragment>
  );
}

AdminPage.propTypes = {
  breadcrumbs: PropTypes.array,
};

AdminPage.defaultProps = {
  breadcrumbs: [],
};

export default AdminPage;
